export default {
  title: '运单',
  list: {
    filterTitle: '运单筛选',
    exportTitle: '运单列表'
  },
  fields: {
    waybillNo: '运单号',
    consignmentNo: '关联委托单号',
    fhNo: '关联 FH 单号',
    relatePlanNo: '关联运输计划单号',
    relateFhNo: '关联发货申请单号',
    transportSegment: '运输段落',
    orderStatus: '主状态',
    mainTransportMode: '本段运输业务类型',
    segmentOrigin: '本段起运地',
    segmentDestination: '本段目的地',
    mainlineOriginCountry: '干线起运国',
    mainlineDestCountry: '干线目的国',
    portOfLoadingCode: '起运港',
    portOfDischargeCode: '目的港',
    transportTool: '交通工具',
    transportToolShipName: '交通工具-船名',
    transportToolVoyageNo: '交通工具-航次',
    transportToolLineCode: '交通工具-航线代码',
    transportToolFlightNo: '交通工具-航班号',
    transportToolVehicleLicence: '交通工具-车牌号',
    transportToolTrainNo: '交通工具-班次号',
    supplierName: '供应商',
    shipper: '承运商',
    shipperShipowner: '船公司',
    shipperAirline: '航空公司',
    shipperExpress: '快递公司',
    shipperTruckCo: '陆运公司',
    shipperRailwayCo: '铁路公司',
    currentTrackingNode: '当前运踪节点',
    currentTrackingStatus: '当前运踪状态',
    hasException: '是否有异常',
    blType: '提单类型',
    blNo: '提单号',
    expressWaybillNo: '快递单号',
    packageBarcodeList: '货物包裹条码',
    orderNo: '合作号',
    carrierName: '航程承运主体',
    originPlace: '航程起运点',
    destinationPlace: '航程目的点',
    etd: 'ETD',
    eta: 'ETA',
    atd: 'ATD',
    ata: 'ATA',
    transitType: '直达/中转',
    transitPoints: '中转点',
    schedule: '班期',
    vesselName: '船名',
    voyageNo: '航次',
    lineCode: '航线代码',
    flightNo: '航班号',
    vehicleNo: '车牌号',
    vesselVoyage: '船名航次',
    aircraftType: '机型',
    airDuration: '空运航程',
    expressProduct: '快递产品',
    railTrainNo: '班次',
    vehicleLicence: '车牌号',
    driverName: '司机姓名',
    driverPhone: '电话',
    driverIdNo: '身份证号',
    vehicleType: '车型',
    containerNo: '箱号',
    boxNos: '箱号',
    createdAt: '创建时间',
    updatedAt: '修改时间',
    remark: '备注',
    operation: '操作'
  },
  placeholders: {
    keyword: '请输入关键词',
    batchKeyword: '请输入多个关键词，空格/逗号/分号分隔',
    select: '请选择',
    dateRange: '请选择日期范围',
    waybillNo: '请输入运单号',
    consignmentNo: '请输入委托单号',
    relatePlanNo: '请输入运输计划单号',
    relateFhNo: '请输入发货申请单号',
    fhNo: '请输入 FH 单号',
    origin: '请输入或选择起运地',
    destination: '请输入或选择目的地',
    mainlineOriginCountry: '请选择干线起运国',
    mainlineDestCountry: '请选择干线目的国',
    portOfLoadingCode: '请输入起运港代码',
    portOfDischargeCode: '请输入目的港代码'
  },
  tags: {
    bl: '提单',
    express: '快递',
    land: '陆运',
    rail: '铁路',
    waybill: '运单'
  },
  trackingStatuses: {
    PENDING: '待处理',
    IN_PROGRESS: '进行中',
    COMPLETED: '已完成'
  },
  orderStatuses: {
    created: '已创建',
    operating: '正操作',
    completed: '已完成',
    cancelled: '已取消',
    frozen: '已冻结'
  },
  exceptionLevels: {
    normal: '正常',
    minor: '一般',
    major: '重要',
    critical: '紧急'
  },
  exceptionOptions: {
    yes: '有异常',
    no: '无异常'
  },
  trackingDetail: {
    title: '运踪轨迹',
    empty: '暂无运踪轨迹',
    actions: {
      packingDetail: '装箱明细'
    },
    etowerPush: {
      retry: '重新推送',
      failureHint: '请补充并保存委托单信息后重新推送',
      status: {
        pending: '推送中',
        processing: '推送中',
        success: '推送成功',
        failed: '推送失败',
        unknown: '推送结果未知，请人工核查'
      }
    },
    attachments: {
      select: '选择附件',
      upload: '上传附件',
      selectTitle: '选择文件管理附件',
      uploadTitle: '上传附件',
      noFiles: '暂无文件',
      fileType: '文件类型',
      fileTypePlaceholder: '请选择文件类型',
      file: '文件',
      chooseFile: '选择文件',
      filePlaceholder: '未选择文件',
      fileTypeRequired: '请选择文件类型',
      fileRequired: '请选择文件',
      fileIdMissing: '文件ID缺失',
      orderIdMissing: '缺少订单ID，无法操作附件',
      loadFilesFailed: '加载文件管理附件失败',
      downloadFailed: '附件下载失败',
      uploadSuccess: '附件已上传到文件管理，保存后绑定到节点',
      uploadFailed: '附件上传失败',
      columns: {
        fileName: '文件名',
        fileType: '文件类型',
        uploadTime: '上传时间',
        fileSize: '文件大小'
      }
    },
    fields: {
      nodeCode: '事件编码',
      nodeName: '节点名称',
      stageName: '阶段',
      nodeStatus: '节点状态',
      location: '地点',
      expressNo: '快递单号',
      consignmentNo: '下单号',
      createdAt: '下单时间',
      pickupTime: '揽件时间',
      pickupLocation: '揽件地点',
      transportTime: '运输时间',
      clearanceTime: '清关时间',
      clearanceLocation: '清关地点',
      deliveryTime: '派送时间',
      signTime: '签收时间',
      estimatedTime: '预计时间',
      actualTime: '实际时间',
      exceptionLevel: '异常等级',
      estimatedRemark: '预计备注',
      actualRemark: '实际备注',
      exceptionRemark: '异常备注',
      attachment: '附件'
    },
    timePrefixes: {
      estimated: '预',
      actual: '实'
    },
    expressTypes: {
      external: '快递运踪',
      domestic: '国内快递',
      international: '国际快递'
    },
    duration: {
      daysHours: '{days}天{hours}小时',
      days: '{days}天',
      hours: '{hours}小时'
    },
    summary: {
      separator: '：',
      waybillNo: '关联运单号',
      packageBarcodeList: '货物包裹条码',
      shipowner: '船公司',
      vesselName: '船名',
      voyageNo: '航次',
      lineCode: '航线代码',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      atd: 'ATD',
      estimatedDuration: '预期航程',
      actualDuration: '实际航程',
      airline: '航空公司',
      flightNo: '航班号',
      aircraftType: '机型',
      expressCompany: '快递承运商',
      expressProduct: '快递产品',
      railTrainNo: '铁路班车',
      vehicleLicence: '车牌号',
      driverName: '司机姓名',
      driverPhone: '电话',
      driverIdNo: '身份证号',
      vehicleType: '车型'
    }
  },
  detail: {
    title: '运单详情',
    tabs: {
      basic: '基础信息',
      tracking: '运踪信息'
    },
    actions: {
      refresh: '刷新',
      edit: '编辑',
      save: '保存',
      cancel: '取消',
      addPacking: '新增装箱明细',
      downloadPackingTemplate: '下载模板',
      importPackingExcel: '导入 Excel',
      addNotify: '新增通知人',
      delete: '删除',
      operationHistory: '操作历史'
    },
    edit: {
      title: '编辑运单'
    },
    empty: {
      contact: '暂无收发通信息',
      operationHistory: '暂无操作历史'
    },
    placeholders: {
      select: '请选择'
    },
    sections: {
      base: '运单基础信息',
      contact: '收发通信息',
      voyage: '航程信息',
      cargoSummary: '实际货物信息（总计）',
      packing: '装箱清单',
      tracking: '运踪信息'
    },
    baseFields: {
      mainTransportMode: '运输方式',
      origin: '起运地',
      destination: '目的地',
      orderRemark: '运输备注',
      supplierRemark: '供应商备注'
    },
    boolean: {
      yes: '是',
      no: '否'
    },
    voyageFields: {
      seaCarrier: '船公司',
      placeOfReceipt: '收货地',
      seaOriginPort: '起运港',
      dischargePort: '卸货港',
      destinationPort: '目的港',
      loadingTerminal: '起运港码头',
      destinationTerminal: '目的港码头',
      seaTransitType: '直达/中转',
      transshipmentPort: '中转港',
      vesselName: '船名',
      voyageNo: '航次',
      lineCode: '航线代码',
      sailingSchedule: '开航班期',
      customsCutoffSchedule: '截关班期',
      etd: 'ETD',
      eta: 'ETA',
      ata: 'ATA',
      atd: 'ATD',
      destinationFreeContainerDays: '目的港免柜期',
      destinationFreeStorageDays: '目的港免堆期',
      devanningDelivery: '拆柜派送',
      weightLimit: '限重',
      specialInstruction: '特殊说明',
      voyageRemark: '备注',
      airline: '航空公司',
      pickupPlace: '提货地',
      originAirport: '起运机场 POL',
      destinationAirport: '目的机场 POD',
      airDestination: '目的地',
      airTransitType: '直航/中转',
      transitAirport: '中转机场',
      flightNo: '航班号',
      aircraftType: '机型',
      flightSchedule: '航班班期',
      airDuration: '航程',
      spaceVolumeLimitCbm: '舱位体积上限（CBM）',
      destinationAirportFreeStorageDays: '目的机场免存期（天）',
      cfsFreeStorageDays: 'CFS仓库免存期（天）',
      expressCarrier: '快递承运商',
      expressProduct: '快递产品',
      railTrainNo: '铁路班次',
      railOriginStation: '起运站',
      railDestinationStation: '目的站',
      vehicleLicence: '车牌号',
      driverName: '司机姓名',
      driverPhone: '电话',
      driverIdNo: '身份证号',
      vehicleType: '车型',
      landOrigin: '起运地',
      landDestination: '目的地'
    },
    contactFields: {
      partyType: '类型',
      company: '公司',
      contactName: '联系人',
      phone: '联系电话',
      country: '国家',
      province: '省/州',
      city: '城市',
      district: '区县',
      town: '街道',
      address: '详细地址',
      postcode: '邮编',
      operation: '操作'
    },
    partyTypes: {
      shipper: '发货人',
      consignee: '收货人',
      notify: '通知人',
      customsShipper: '报关发货地址',
      customsConsignee: '报关收货地址',
      clearanceShipper: '清关发货地址',
      clearanceConsignee: '清关收货地址',
      actualPickup: '实际提货地',
      actualDelivery: '实际送达地'
    },
    cargoFields: {
      pieces: '纸箱数',
      grossWeight: '毛重(KGS)',
      volume: '体积(CBM)',
      chargeableWeight: '计费重(KGS)',
      palletSize: '托盘尺寸(长×宽×高 cm)',
      palletQty: '托盘数量'
    },
    packingFields: {
      lineNo: '行号',
      containerNo: '箱号',
      containerType: '箱型',
      palletNo: '栈板号',
      sealNo: '封条号',
      pieces: '纸箱数',
      grossWeight: '毛重(KGS)',
      volume: '体积(CBM)',
      goodsNameEn: '英文品名',
      marks: '唛头',
      cartonNos: '纸箱号',
      remark: '备注',
      operation: '操作'
    },
    operationHistory: {
      title: '操作历史'
    },
    packingTemplate: {
      fileName: '装箱清单模板.xlsx',
      sheetName: '装箱清单'
    }
  },
  messages: {
    loadListFailed: '加载运单列表失败',
    loadDetailFailed: '加载运单详情失败',
    saveDetailSuccess: '运单详情已保存',
    saveDetailFailed: '保存运单详情失败',
    contactPartyRequired: '收发通信息需要且仅需要一条发货人和一条收货人',
    contactAddressRequired: '收发通信息的联系人、联系电话、国家不能为空',
    customsContactAddressRequired: '报关/清关地址的联系电话、国家不能为空',
    fieldRequired: '{field}不能为空',
    packingRequired: '装箱清单第 {line} 行「{field}」不能为空',
    downloadPackingTemplateFailed: '下载装箱清单模板失败',
    importPackingSuccess: '已导入 {count} 行装箱清单',
    importPackingFailed: '导入装箱清单失败',
    packingWorksheetMissing: '未读取到工作表',
    packingHeaderMissing: '未匹配到装箱清单表头',
    packingNoData: 'Excel 中没有可导入的数据',
    importPackingOverwriteTitle: '确认覆盖装箱清单？',
    importPackingOverwriteContent: '导入 Excel 会替换当前装箱清单，已填写的行将被覆盖。',
    trackingNodeRequired: '运踪节点缺少运单号或节点标识，暂无法保存',
    loadOperationHistoryFailed: '加载操作历史失败',
    idRequired: '缺少运单 ID',
    deleteConfirmTitle: '确认删除运单？',
    deleteConfirmContent: '删除运单 {no} 后，运输委托单详情页运踪数据会同步删除。',
    deleteSuccess: '运单已删除',
    deleteFailed: '删除运单失败，请重试'
  }
}
